import React, { useState } from "react";
import { CS_TEL_HREF, CS_SMS_HREF, CS_LABEL, AUTO_LABEL } from "@/brand";
import axios from "axios";
import { toast } from "sonner";
import { Phone, Mail, MapPin } from "lucide-react";
import { Reveal } from "@/components/effects/Reveal";
import { T } from "@/context/SiteContent";
import { API } from "@/config";

export const Contact = () => {
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [sending, setSending] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await axios.post(`${API}/contact`, form);
      toast.success("Message sent! We'll reply within a firefly's breath.");
      setForm({ name: "", email: "", phone: "", message: "" });
    } catch (e) {
      toast.error("Could not send. Please try again.");
    } finally { setSending(false); }
  };
  return (
    <section id="contact" className="section relative">
      <div className="section-tint" />
      <div className="container grid md:grid-cols-2 gap-14 items-start">
        <Reveal>
          <p className="eyebrow mb-4"><T k="contact.eyebrow" fallback="Get in touch" /></p>
          <h2 className="font-serif text-5xl md:text-6xl tracking-tight leading-none"><T k="contact.headline" fallback="Whisper to the willow." /></h2>
          <p className="mt-6 text-[#B9C8D5] max-w-md"><T k="contact.paragraph" fallback="Custom bundles, group trips, or last-minute magic — we love making Disney easier." /></p>
          <div className="mt-10 space-y-4 text-[#F6F1E4]">
            <div className="flex items-center gap-3"><Phone className="w-4 h-4 text-[#FFD166]" /> <a href={CS_TEL_HREF} className="hover:text-[#FFD166]" data-testid="contact-cs-phone"><T k="footer.phone" fallback={CS_LABEL} /></a> <a href={CS_SMS_HREF} className="text-xs text-[#FFD166] underline ml-1" data-testid="contact-text-us">Text us</a></div>
            <div className="text-xs text-[#B9C8D5] pl-7" data-testid="contact-auto-phone">{AUTO_LABEL} — automated texts only</div>
            <div className="flex items-center gap-3"><Mail className="w-4 h-4 text-[#FFD166]" /> <a href="mailto:info@enchantedgearrentals.com" className="hover:text-[#FFD166]"><T k="footer.email" fallback="info@enchantedgearrentals.com" /></a></div>
            <div className="flex items-center gap-3"><MapPin className="w-4 h-4 text-[#FFD166]" /> <T k="contact.service_area" fallback="Serving all of Central Florida" /></div>
          </div>
        </Reveal>
        <Reveal delay={0.15}>
          <form onSubmit={submit} className="glass p-8 space-y-4" data-testid="contact-form">
            <div className="grid md:grid-cols-2 gap-4">
              <input className="input" placeholder="Name" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="contact-name" />
              <input className="input" type="email" placeholder="Email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="contact-email" />
            </div>
            <input className="input" placeholder="Phone (optional)" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} data-testid="contact-phone" />
            <textarea className="input min-h-[140px]" placeholder="Tell us about your trip…" required value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} data-testid="contact-message" />
            <button className="btn-primary w-full" disabled={sending} data-testid="contact-submit">
              {sending ? "Sending…" : "Send Message"}
            </button>
          </form>
        </Reveal>
      </div>
    </section>
  );
};
